/**
 * サンプルデータセットの定義
 *
 * 新しいサンプルデータセットを追加する方法:
 * 1. CSVファイルを src/app/public/sample-data/ 以下に配置
 * 2. 下記のSAMPLE_DATASETS配列に定義を追加
 *
 * 詳細は docs/adding-sample-data.md を参照
 */

export interface SampleDataset {
  /** データセットの一意な識別子 */
  id: string;
  /** ユーザーに表示される名前 */
  name: string;
  /** sample-dataディレクトリからの相対パス */
  path: string;
  /** データセットの行数 */
  rows: number;
  /** データセットの列数 */
  columns: number;
  /** データセットの主な用途（カンマ区切り） */
  purpose: string;
  /** 初心者向けかどうか */
  recommended?: boolean;
}

/**
 * LauncherViewに表示するサンプルデータセット一覧
 * 表示順序は配列の順番に従う
 */
export const SAMPLE_DATASETS: SampleDataset[] = [
  {
    id: 'penguins',
    name: 'Palmer Penguins',
    path: 'penguins/penguins.csv',
    rows: 344,
    columns: 8,
    purpose: 'Classification, visualization',
    recommended: true,
  },
  {
    id: 'gapminder',
    name: 'Gapminder',
    path: 'gapminder/gapminder.csv',
    rows: 1704,
    columns: 6,
    purpose: 'Time series, global development',
  },
  {
    id: 'mpg',
    name: 'Auto MPG',
    path: 'mpg/mpg.csv',
    rows: 398,
    columns: 9,
    purpose: 'Regression, correlation',
  },
  {
    id: 'bike-daily',
    name: 'Bike Sharing (Daily)',
    path: 'bike-sharing/bike-sharing-daily.csv',
    rows: 731,
    columns: 16,
    purpose: 'Count data, Poisson regression',
  },
  {
    id: 'bike-hourly',
    name: 'Bike Sharing (Hourly)',
    path: 'bike-sharing/bike-sharing-hourly.csv',
    rows: 17379,
    columns: 17,
    purpose: 'Large datasets, hourly patterns',
  },
  {
    id: 'world-bank',
    name: 'World Bank',
    path: 'world-bank/world-bank.csv',
    rows: 50,
    columns: 10,
    purpose: 'Economic analysis, statistics',
    recommended: true,
  },
  {
    id: 'earthquakes',
    name: 'Earthquakes (2024-09)',
    path: 'earthquakes/earthquakes-2024-09.csv',
    rows: 1041,
    columns: 7,
    purpose: 'Datetime visualization, geographic analysis',
    recommended: true,
  },
  {
    id: 'iris',
    name: 'Iris',
    path: 'iris/iris.csv',
    rows: 150,
    columns: 5,
    purpose: 'Classic classification',
  },
];
